export default "__VITE_ASSET__BXx6jTTt__"